import ControlProps from '../../../mixins/ControlProps';
import { PhoneInputProperty } from '../enums';
import InputProps from '../../../shared/input/mixins/InputProps';
import { InputProperty } from '../../../shared/input/enums';
import { PHONE_INPUT_DEFAULT_MASK } from '../constants';

const PhoneInputProps = {
  props: {
    ...ControlProps.props,
    [PhoneInputProperty.FillType]: InputProps.props[InputProperty.FillType],
    [PhoneInputProperty.Mask]: {
      default: PHONE_INPUT_DEFAULT_MASK,
      type: String,
    },
  },
};

export default PhoneInputProps;
